export default "/_next/static/chunks/fonts/OpenSans-Regular-latin-21a4d962f9b72497d51798214825b74a.woff2";